import RecoverStep from "./recover_step";
import {attachSelectableHandler, setAzureExportState} from "../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";
import {getRelatedTab} from 'modules/single-page-app';
import {getPageData} from 'modules/page-events';

const TEMPLATE = 'type-rb';

export default class TypeStepRB extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    data.tmp = {previousStep: fr.currentStep};
    data.recovery.virtualization = {isLocal: null};
    data.render = {readyToRender: false};
    if (data.virtualizationLocation && data.renderedFlowType === data.type) {
      data.render.readyToRender = true;
    } else {
      data.renderedFlowType = data.type;
      $.ajax({
        type: "GET",
        url: this.buildVirtLocationUrl(data),
        dataType: AJAX_DATA_TYPE_JSON,
        contentType: "application/json",
        success: function (response) {
          data.virtualizationLocation = {
            cloud: response.data['cloud_vo'],
            ftpsExportFFR: response.data['ftps_export_ffr'],
            ftpsExportVirtualDisk: response.data['ftps_export_virtual_disk'],
            azureDirectRestore: response.data['azure_direct_restore'],
          };

          data.render.readyToRender = true;
          fr.render('typeRB');
        }
      }).fail(fr.defaultAJAXErrorHandler);
    }
  }

  buildVirtLocationUrl(data) {
    let url = `/api/recover_flow/get_available_recovery_options/${data.clientId}`;
    url += "/" + (data.applianceId ?? 0);
    if (data.deviceId) {
      url += "/" + data.deviceId;
    }
    return url;
  }

  postRender(data, el, fr) {
    attachSelectableHandler(el, (d) => {
      data.recovery.type = d.type
      if (d.type === 'azure_direct_restore') {
        data.render.readyToRender = false;
        fr.render('typeRB');
        const successCallback = (response, status) => {
          const pageData = getPageData('page_rmc_frame_data');
          const azureTab = getRelatedTab('azure_export/view', pageData.userType)
          fr.close();
          tabs_goto(`/azure_export/view`, `li.${azureTab}`);
        }
        setAzureExportState(data, fr, successCallback);
      }
    });
  }

  transitionBack(data, el, fr) {
    const previousPage = (data.flowName === 'GeneralResellerRecoverFlow' && !data.clientHasBrcAndX360Recover)
        ? 'clientSelect'
        : 'recoverToolSelect';

    fr.goTo(previousPage);
  }

}
